// src/components/ProjectSummaryCard.tsx
import React from 'react';
import * as AntdIcons from '@ant-design/icons';
// Import the specific Ant Design type for Icon Components
import { IconComponentProps } from '@ant-design/icons/lib/components/Icon';
// NOTE: Depending on your Antd version/setup, you might need to adjust the import path.
// A simpler, often working approach is to use a more generic type:

interface ProjectSummary {
    icon: string;
    count: number;
    label: string;
    status: 'completed' | 'required' | 'in-progress' | 'delayed';
}

const statusColors: { [key: string]: string } = {
    completed: 'text-purple-600 bg-purple-100',
    required: 'text-blue-600 bg-blue-100',
    'in-progress': 'text-green-600 bg-green-100',
    delayed: 'text-orange-600 bg-orange-100',
};

const ProjectSummaryCard: React.FC<{ data: ProjectSummary }> = ({ data }) => {
    // 1. Get the component from the map.
    const IconComponent = AntdIcons[data.icon as keyof typeof AntdIcons];


    const TypedIconComponent = IconComponent as React.ComponentType<any>;


    return (
        <div className="flex rounded items-center p-4 border w-full">
            <div className={`w-10 h-10 flex items-center mr-2 justify-center rounded-md ${statusColors[data.status]}`}>

                {TypedIconComponent && <TypedIconComponent className="text-xl" />}
            </div>
            <div className="">   <h5 className=" text-gray-800 ">{data.count}</h5>
                <p className="text-sm text-gray-500">{data.label}</p></div>
        </div>
    );
};

export default ProjectSummaryCard;